module.exports = __webpack_public_path__ + "static/img/2020-10-04 11.42.40.e02bfb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2020-10-04 11.42.40.jpg
// module id = Qpnf
// module chunks = 4